import { FormattedMessage, useIntl } from 'react-intl';
import { FieldError, useFormContext, useWatch } from 'react-hook-form';
import { FormSection } from '../FormSection';
import { FormElement } from '../FormElement';
import { InputText } from '../Inputs/InputText';
import { InputPostalCode } from '../Inputs/InputPostalCode';
import { SchemaType } from '@/hooks/useStudentFormSchema';

type StudentFormType =
  | SchemaType<'create' | 'update', 'transportation'>
  | SchemaType<'create' | 'update', 'travels'>
  | SchemaType<'create' | 'update', 'child-and-youth'>;

type DeliveryAddressErrors = {
  delivery_address?: {
    care_of?: FieldError;
    street?: FieldError;
    zip_code?: FieldError;
    city?: FieldError;
  };
};

interface StudentDeliveryAddressProps {
  editMode: boolean;
}

export const StudentDeliveryAddress = ({
  editMode,
}: StudentDeliveryAddressProps) => {
  const { formatMessage } = useIntl();
  const {
    control,
    formState: { errors },
  } = useFormContext<StudentFormType>();
  const careOf = useWatch({
    control,
    name: 'delivery_address.care_of' as never,
  }) as string | undefined;

  const typedErrors = errors as DeliveryAddressErrors;

  return (
    <FormSection
      title={<FormattedMessage defaultMessage="Leveransadress" />}
      editMode={editMode}
    >
      <div className="flex flex-col gap-2">
        <FormElement
          id="delivery_address.care_of"
          label={<FormattedMessage defaultMessage="c/o" />}
          visible={editMode || !!careOf}
          input={
            <InputText
              name={'delivery_address.care_of' as never}
              control={control}
              editMode={editMode}
              error={typedErrors.delivery_address?.care_of}
              placeholder={formatMessage({ defaultMessage: 'Namn' })}
              helperTextReserveSpace
            />
          }
        />
        <FormElement
          id="delivery_address.street"
          label={<FormattedMessage defaultMessage="Adress" />}
          required={editMode}
          input={
            <InputText
              name={'delivery_address.street' as never}
              control={control}
              editMode={editMode}
              error={typedErrors.delivery_address?.street}
              helperTextReserveSpace
            />
          }
        />
        <FormElement
          id="delivery_address.zip_code"
          label={<FormattedMessage defaultMessage="Postnummer" />}
          required={editMode}
          input={
            <InputPostalCode
              name={'delivery_address.zip_code' as never}
              control={control}
              editMode={editMode}
              error={typedErrors.delivery_address?.zip_code}
              helperTextReserveSpace
            />
          }
        />
        <FormElement
          id="delivery_address.city"
          label={<FormattedMessage defaultMessage="Postort" />}
          required={editMode}
          input={
            <InputText
              name={'delivery_address.city' as never}
              control={control}
              editMode={editMode}
              error={typedErrors.delivery_address?.city}
              helperTextReserveSpace
            />
          }
        />
      </div>
    </FormSection>
  );
};
